import React from "react";
import { Button, Typography } from "@mui/material";
import { Link } from "react-router";
import { getCaseLink, getProductNameBy } from "../../../services/productService";
import useProductParams from "../../../hooks/useProductParams";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";
import ProductBox from "@/src/components/ProductBox/ProductBox";

export default function InquiryToCustomerAnsweredPage() {
  const { productName, productId } = useProductParams();

  return (
    <LayoutAuthenticated>
      <ProductBox variant={"hintbox"} headline={"Vielen Dank für Ihre Rückmeldung!"}>
        <Typography variant={"body2"}>
          Wir haben Ihre Rückmeldung erhalten und bearbeiten Ihren Fall entsprechend weiter. Bei offenen Fragen oder Neuigkeiten zu Ihrem Fall, melden wir uns
          umgehend bei Ihnen zurück!
        </Typography>
        <Button
          sx={{ marginTop: "1rem" }}
          variant={"contained"}
          component={Link}
          to={getCaseLink({ name: getProductNameBy("urlPartShort", productName), id: productId })}
        >
          Zurück zu meinem Fall
        </Button>
      </ProductBox>
    </LayoutAuthenticated>
  );
}
